/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Weekly_Hours_CapInputs */

const en_why_listening_weekly_hours_cap = /** @type {(inputs: Why_Listening_Weekly_Hours_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly hours cap`)
};

const es_why_listening_weekly_hours_cap = /** @type {(inputs: Why_Listening_Weekly_Hours_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límite de horas semanales`)
};

/**
* | output |
* | --- |
* | "Weekly hours cap" |
*
* @param {Why_Listening_Weekly_Hours_CapInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_weekly_hours_cap = /** @type {((inputs?: Why_Listening_Weekly_Hours_CapInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Weekly_Hours_CapInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_weekly_hours_cap(inputs)
	return en_why_listening_weekly_hours_cap(inputs)
});